<template>
  <div class="AdminOrderDetail" id="printAdmin" v-loading="isLoading">
    <div
      id="hideButton1"
      class="AdminOrderDetailHeader"
    >
      <div
        class="cursorPointer"
        @click="gotoHome"
      >
        <font-awesome-icon
          style="margin-left: 7px;"
          :icon="['fal', 'angle-left']"
          @click="gotoHome"
          size="2x"
        />
        <span class="u-ml10 TextWithIcon">
          注文一覧
        </span>
      </div>
      <el-row>
        <el-col :span="24">
          <div
            class="AdminOrderDetailHeaderTopRight"
            id="AdminOrderDetailHeaderOptions"
          >
            <el-button @click="onClickPrintOrderPreview(orderDetailId)"
              >印刷</el-button
            >
            <el-button @click="printApprovalSet()"
              >校了セット印刷</el-button
            >
            <el-select
              @change="changeAssignOption($event)"
              :value="assignName"
              placeholder="担当を割当てる"
              id="assignUserSelectBox"
            >
              <div v-for="(assignee, index) in users" v-bind:key="index">
                <el-option :value="assignee">{{ assignee.name }}</el-option>
              </div>
            </el-select>
            <el-button
              type="primary"
              @click="_onClickOrderMessage()"
            >
              <font-awesome-icon
                :icon="['fal', 'comment']"
                size="1x"
              />メッセージ確認
            </el-button>
            <SignatureInput
              :signature="primaryOrder && primaryOrder.detail && primaryOrder.detail.signature"
              :isEditable="primaryOrder && primaryOrder.detail && primaryOrder.detail.signature === null"
            />
            <el-button @click="openOrderManagementDialog()"
              >注文管理</el-button
            >
          </div>
        </el-col>
      </el-row>

      <!-- 注文ステータス -->
      <div
        v-if="order.status"
        class="order-status"
      >
        注文ステータス：
        <span class="statusBold">
          {{ order.status.name }}
        </span>
      </div>

      <!-- 注文ステータス -> キャンセルリクエスト時 -->
      <el-row>
        <div
          v-if="orderStatus === 'CANCEL_REQUEST'"
          class="AdminOrderDetailHeaderTopLeft"
        >
          <el-select :value="selectedValue">
            <el-option value="1">
              <el-button
                type="text"
                class="black-text"
                @click="getAcceptRequestDialog()"
              >
                依頼を受理する
              </el-button>
            </el-option>
            <el-option value="2">
              <el-button
                type="text"
                class="black-text"
                @click="getCancelRequestDialog()"
              >
                依頼を取り消す
              </el-button>
            </el-option>
          </el-select>
        </div>
      </el-row>
    </div>

    <!-- ステータス -->
    <!-- Step1: 新規注文 = PROCESSING -->
    <!-- Step2: レイアウト作成中 = PROCESSING_CREATING_LAYOUT -->
    <!-- Step3: レイアウト調整中 = REVISING_LAYOUT -->
    <!-- Step4: 注文確定 = CONFIRMED -->
    <!-- Step5: 発送済み = SHIPPED -->
    <div
      id="hideButton2"
      class="AdminOrderDetailHeader"
    >
      <el-row>
        <el-col :span="24">
          <div
            v-if="buttonGroup"
            id="btn-group"
            class="AdminOrderDetailHeaderTopCenter flex center"
          >
            <!-- ステータス: スペーサー -->
            <div class="box grow" />

            <!-- ステータス: レイアウト作成 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(0)"
              :plain="computedStepByOrderStatus > 0"
              :disabled="fetchIsDisabledBySteps([1, 3, 4])"
              @click="_onClickLayoutCreating()"
            >
              {{ computedStepByOrderStatus > 0 ? "レイアウト作成開始済み" : "レイアウト作成を開始する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow1Visible"
              id="arrow-icon1"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: レイアウト調整 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(1)"
              :plain="computedStepByOrderStatus > 1"
              :disabled="fetchIsDisabledBySteps([0, 2, 4])"
              @click="_onClickLayoutAdjust()"
            >
              {{ computedStepByOrderStatus > 1 ? "レイアウト調整開始済み" : "レイアウト調整を開始する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow1Visible"
              id="arrow-icon1"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: 注文確定 -->
            <el-button
              v-if="isNeededLayoutReply"
              class="statusButton"
              :type="fetchTypeByStep(2)"
              :plain="computedStepByOrderStatus > 2"
              :disabled="fetchIsDisabledBySteps([0, 1, 3])"
              @click="_onClickConfirmOrder()"
            >
              {{ computedStepByOrderStatus > 2 ? "注文を確定済み" : "注文を確定する" }}
            </el-button>

            <!-- ステータス: アロー -->
            <i
              v-if="isArrow2Visible"
              id="arrow-icon2"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- ステータス: 発送済み -->
            <el-button
              class="statusButton"
              :type="fetchTypeByStep(3)"
              :plain="computedStepByOrderStatus > 3"
              :disabled="fetchIsDisabledBySteps([0, 1, 2, 4])"
              @click="_onClickShippedOrder()"
            >
              {{ computedStepByOrderStatus > 3 ? "発送済み" : "発送済みにする" }}
            </el-button>

            <!-- ステータス: スペーサー -->
            <div class="box grow" />
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <!-- 基本情報 -->
      <el-col :span="14">
        <div class="basic-info">
          <table class="adminOrderDetailTable">
            <tr>
              <th class="adminOrderDetailTable-th" colspan="2">基本情報</th>
            </tr>
            <tr v-for="item in basicInformations" :key="item[0]">
              <td class="adminOrderDetailTable-td">{{ item[0] }}</td>
              <td v-if="item[0] == '注文番号'" class="adminOrderDetailTable-td">
                {{ item[1] ? "6" + item[1] : item[1] }}
              </td>
              <td v-else class="adminOrderDetailTable-td">{{ item[1] }}</td>
            </tr>
          </table>
        </div>
      </el-col>
      <!-- お客様情報 -->
      <el-col :span="10">
        <div class="basic-info">
          <table class="adminOrderDetailTable">
            <tr>
              <th
                style="padding: 0px 5px;"
                class="adminOrderDetailTable-th"
                colspan="2"
              >
                <span style="line-height:2rem">お客様情報</span>
                <el-button
                  id="editBtn"
                  class="customer-edit-btn"
                  type="secondary"
                  @click="goToEdit()"
                  >編集</el-button
                >
              </th>
            </tr>
            <tr v-for="item in order.customerInformation" :key="item[0]">
              <td class="adminOrderDetailTable-td">{{ item[0] }}</td>
              <td class="adminOrderDetailTable-td Note">
                <div v-if="isAttachments(item[1])">
                  <AttachmentResolver
                    v-for="(attachment, index) in item[1]"
                    :key="index"
                    :src="attachment.src"
                  />
                </div>
                <span v-else>{{ item[1] }}</span>
              </td>
            </tr>
          </table>
        </div>
      </el-col>
    </el-row>

    <div class="basic-info layout-images-admin-section" v-show="showLayoutManagement">
      <table class="adminOrderDetailTable layout-images-admin-table">
        <tr>
          <th class="adminOrderDetailTable-th">レイアウト</th>
        </tr>
      </table>
      <div class="layout-images-admin-subheader">
        <span class="layout-images-admin-count">レイアウト数：{{ allLayoutImages.length }} 枚</span>
        <div class="layout-images-admin-actions">
          <el-button
            v-if="hasApprovedLayoutImage"
            type="warning"
            size="small"
            @click="unapproveAllLayoutImages"
          >校了の取り消し</el-button>
          <el-button
            type="primary"
            size="small"
            @click="_onClickOrderMessage(orderDetailId)"
          >メッセージ確認</el-button>
        </div>
      </div>
      <div class="layout-images-admin-grid">
        <div
          v-for="img in layoutImagesResolved"
          :key="img.id"
          class="layout-image-admin-card"
          :class="{ 'layout-image-admin-approved': img.isApproved }"
        >
          <div class="layout-image-admin-card-inner" @click="openAdminLayoutImageDialog(img)">
            <div class="layout-image-admin-thumb-wrapper">
              <img :src="img.resolvedUrl" v-if="img.resolvedUrl" class="layout-image-admin-thumb" />
            </div>
            <div v-if="img.isApproved" class="layout-image-admin-approved-badge" title="校了済み">
              <i class="el-icon-check"></i>
            </div>
            <button
              type="button"
              class="layout-image-admin-delete"
              title="レイアウト画像を削除"
              @click.stop="removeLayoutImage(img)"
            >
              <i class="el-icon-delete"></i>
            </button>
          </div>
          <p class="layout-image-admin-filename">{{ img.fileName || img.imageKey }}</p>
        </div>
        <!-- Add layout image button -->
        <div class="layout-image-admin-add-card">
          <el-upload
            ref="layoutImageUpload"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onLayoutImageFileSelected"
            accept=".jpg,.jpeg,.png"
          >
            <div class="layout-image-admin-add-inner">
              <span>+</span>
            </div>
          </el-upload>
          <p class="layout-image-admin-filename">jpg または png ファイル</p>
        </div>
      </div>
    </div>

    <div id="thirdTable">
      <!-- 商品情報 -->
      <el-col :span="24">
        <div class="basic-info">
          <div id="productTable">
            <el-table
              :data="productInformations"
              class="Product-Table"
              header-cell-class-name="ProductInforamtionTableHeader"
              cell-class-name="Product-Table-Cell"
              row-class-name="no-hover"
              :span-method="arraySpanMethod"
            >
              <el-table-column class-name="TextLeft" label="商品情報">
                <el-table-column
                  prop=""
                  label=""
                  class-name="TextCenter"
                  width="40px"
                >
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.denpyogyo }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop=""
                  label="商品CD"
                  class-name="TextLeft"
                  min-width="40px"
                >
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.productVariationId }}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="商品名" class-name="TextLeft">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.name }}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="単価" width="80px">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.unitPrice | addComma }}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="数量" width="80px">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.quantity }}
                  </template>
                </el-table-column>
                <el-table-column prop="" class-name="itemHeader" label="金額">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.price | addComma }}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="摘要" min-width="40px">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.tekiyo }}
                  </template>
                </el-table-column>
                <el-table-column prop="" label="客注No" min-width="40px">
                  <template slot-scope="scope" v-if="scope.row">
                    {{ scope.row.kyakuchuno }}
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </div>
    <el-row id="preview">
      <!-- 注文情報 -->
      <el-col :span="24">
        <div class="basic-info" v-if="isValidOrderAvailable">
          <table class="adminOrderDetailTable">
            <tr>
              <th class="adminOrderDetailTable-th" colspan="2">注文情報</th>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">
                <TabletPreview
                  :order="order"
                  :frontColor="(order.fontColors && order.fontColors[1]) || { name: '金色', colorCode: 'yellow' }"
                  :backColor="(order.fontColors && order.fontColors[0]) || { name: '白', colorCode: 'white' }"
                />
              </td>
              <td class="Text">
                <div class="Flow" style="height:500px;overflow: scroll;">
                  <div
                    v-if="!showLayoutManagement && approvedLayoutImage"
                    class="approved-layout-above-info"
                  >
                    <h2 class="approved-layout-above-info-title">レイアウト</h2>
                    <img
                      :src="approvedLayoutImage.resolvedUrl"
                      class="approved-layout-above-info-img"
                      @click="openAdminLayoutImageDialog(approvedLayoutImage)"
                    />
                  </div>
                  <InformationTable
                    title="お客様情報"
                    :source="order.customerInformation"
                  />
                  <InformationTable
                    title="自由項目"
                    :source="order.customFieldInformation"
                  />
                  <InformationTable
                    title="商品カテゴリ"
                    :source="order.categoryInformation"
                  />
                  <InformationTable
                    title="商品情報"
                    :source="order.productInformation"
                  />
                  <InformationTable
                    title="注文タイプ情報"
                    :source="order.orderTypeInformation"
                  />
                  <InformationTable
                    id="typography"
                    title="彫り・書き/書式情報"
                    :source="order.typographyInformation"
                  />
                  <InformationTable
                    title="詳細情報"
                    :source="order.detailInformation"
                  />
                  <div
                    class="UserUploadImgTitleConfirm"
                    v-if="order.detail.customFamilyEmblemUrl"
                  >
                    ユーザー選択画像(家紋)
                  </div>
                  <img
                    v-if="order.detail.customFamilyEmblemUrl"
                    title="ユーザー選択画像"
                    class="UserUploadImgConfirm"
                    :src="customFamilyEmblemImg"
                    alt
                  />
                  <div
                    class="UserUploadImgTitleConfirm"
                    v-if="order.detail.customSanskritCharacterUrl"
                  >
                    ユーザー選択画像(梵字)
                  </div>
                  <img
                    v-if="order.detail.customSanskritCharacterUrl"
                    title="ユーザー選択画像(梵字)"
                    class="UserUploadImgConfirm"
                    :src="customSanskritCharacterImg"
                    alt
                  />
                  <div
                    class="UserUploadImgTitleConfirm"
                    v-if="order.detail.customSanskritCharacterBackUrl"
                  >
                    ユーザー選択画像(裏梵字)
                  </div>
                  <img
                    v-if="order.detail.customSanskritCharacterBackUrl"
                    title="ユーザー選択画像(裏梵字)"
                    class="UserUploadImgConfirm"
                    :src="customSanskritCharacterBackImg"
                    alt
                  />
                  <template v-if="order.detail.columns">
                    <InformationTable
                      v-for="(data, index) in order.columnsInformation"
                      :key="index"
                      :title="`${index + 1}霊目`"
                      :source="data"
                    />
                  </template>
                  <InformationTable
                    title="その他"
                    :source="order.otherInformation"
                  />

                  <InformationTable
                    title="異体字注意点"
                    :source="order.itaijiPointsInformation"
                  />
                </div>
              </td>
            </tr>
          </table>
        </div>
      </el-col>
    </el-row>

    <!-- Admin Layout Image Dialog -->
    <el-dialog
      :visible.sync="adminLayoutImageDialogVisible"
      width="80%"
      center
    >
      <div v-if="adminSelectedLayoutImage" class="layout-image-dialog-content">
        <p class="layout-image-dialog-filename">{{ adminSelectedLayoutImage.fileName || adminSelectedLayoutImage.imageKey }}</p>
        <div class="layout-image-dialog-preview">
          <img :src="adminSelectedLayoutImage.resolvedUrl" v-if="adminSelectedLayoutImage.resolvedUrl" class="layout-image-full" />
        </div>
      </div>
    </el-dialog>

    <!-- Rodan設定値 -->
    <div
      class="basic-info"
      style="margin-bottom: 2rem"
      v-if="
        order.detail &&
        order.detail.columns &&
        isShowRodanSetValues
      "
    >
      <AdminOrderDetailRodanSetValues
        :order="order"
      />
    </div>

    <!-- Dialogs Division -->
    <div class="AdminOrderDetailDialog">
      <!-- お局様情報: customer dialog -->
      <el-dialog
        :visible.sync="editDialog"
        :close-on-click-modal="!isSendingRequest"
        width="40%"
      >
        <table class="adminOrderDetailTable">
          <tr>
            <th class="adminOrderDetailTable-th" colspan="2">お客様情報</th>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">お名前</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.name"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">郵便番号</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.zipcode"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">住所</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.address"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">電話番号</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.tel"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">宗派</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.sect"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">菩提寺</td>
            <td class="adminOrderDetailTable-td">
              <el-form>
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.familyTemple"
                  ></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
          <tr>
            <td class="adminOrderDetailTable-td">備考</td>
            <td class="adminOrderDetailTable-td Note">
              <el-form>
                <el-form-item>
                  <el-input v-model="customerItems.customer.note"></el-input>
                </el-form-item>
              </el-form>
            </td>
          </tr>
        </table>

        <!-- お局様情報: アクション -->
        <span>
          <el-button
            id="btnText"
            type="text"
            :disabled="isSendingRequest"
            @click="onCancelUpdate()"
          >
            キャンセル
          </el-button>
        </span>
        <span>
          <el-button
            id="btnText"
            type="text"
            :loading="isSendingRequest"
            @click="updateOrder()"
          >
            保存する
          </el-button>
        </span>
      </el-dialog>

      <!-- 依頼を受理: accept order dialog -->
      <el-dialog
        :visible.sync="acceptOrderDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          依頼を受理しますか？
        </span>

        <!-- 依頼を受理: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="acceptOrderDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickAcceptOrder()"
          >
            受理する
          </el-button>
        </span>
      </el-dialog>

      <!-- 注文キャンセル: cancel order dialog -->
      <el-dialog
        :visible.sync="cancelOrderDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          依頼を取り消しますか？
        </span>

        <!-- 注文キャンセル: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelOrderDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickCancelOrder()"
          >
            取り消す
          </el-button>
        </span>
      </el-dialog>

      <!-- レイアウト作成: create layout order dialog -->
      <el-dialog
        :visible.sync="layoutCreatingDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 1 ? "レイアウト作成開始に戻しますか？" : "レイアウト作成を開始しますか？" }}
        </span>

        <!-- レイアウト作成: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelLayoutCreating()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="startLayoutCreating()"
          >
            {{ computedStepByOrderStatus > 1 ? "戻す" : "開始する" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- レイアウト調整: adjust layout order dialog -->
      <el-dialog
        :visible.sync="layoutAdjustDialogVisible"
        :close-on-click-modal="!isSendingRequest && !isUploadingFile"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 2 ? "レイアウト調整開始に戻しますか？" : "レイアウト調整を開始しますか？" }}
        </span>
        <AdminOrdersImageUploader
          ref="adminOrdersImageUploader"
          v-if="computedStepByOrderStatus < 2"
          class="mt-4"
          :images="images"
          @updateImageFile="updateImageFile"
          @update:isUploadingFile="updateIsUploadingFile"
          @initImageFile="images = []"
        />

        <!-- レイアウト調整: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest || isUploadingFile"
            @click="cancelLayoutAdjust()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :disabled="isUploadingFile"
            :loading="isSendingRequest"
            @click="startLayoutAdjust()"
          >
            {{ computedStepByOrderStatus > 2 ? "戻す" : "開始する" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 出荷日を選択: delivery date input dialog -->
      <el-dialog
        class="dateInputDialog"
        :visible.sync="dateInputDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          出荷日を選択してください。
        </span>
        <div class="FormGroup">
          <el-date-picker
            v-model="fixedShippingDate"
            id="date-input"
            class="date-input"
            type="date"
            placeholder="出荷日を選択してください"
            :editable="false"
          />
        </div>

        <!-- 出荷日を選択: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelDateInput()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickShippingDateOK()"
          >
            OK
          </el-button>
        </span>
      </el-dialog>

      <!-- 注文を確定: confirm order dialog -->
      <el-dialog
        :visible.sync="confirmOrderDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          {{ computedStepByOrderStatus > 3 ? "注文確定に戻しますか？" : "注文を確定しますか？" }}
        </span>

        <!-- 注文を確定: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="cancelConfirmOrder()"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickConfirm()"
          >
            {{ computedStepByOrderStatus > 3 ? "戻す" : "確定" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 校了セット印刷確認 -->
      <el-dialog
        :visible.sync="printApprovalSetDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          校了セットを印刷しますか？
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="printApprovalSetDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="printApprovalSet()"
          >
            印刷する
          </el-button>
        </span>
      </el-dialog>

      <!-- 発送済み: shipped order dialog -->
      <el-dialog
        :visible.sync="shippedDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <span class="dialog-text">
          この注文を発送済みにしますか？
        </span>

        <!-- アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="shippedDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="_onClickShipped()"
          >
            はい
          </el-button>
        </span>
      </el-dialog>

      <!-- 担当割り当て: user assign dialog -->
      <el-dialog
        class="assignerDialog"
        :visible.sync="userAssignDialogVisible"
        :close-on-click-modal="!isSendingRequest"
        width="35%"
        center
      >
        <label class="dialog-text">
          この注文の担当を
          <br />
          {{ selectUserName }}
          <br />に割り当てますか?
        </label>

        <!-- 担当割り当て: アクション -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            class="cancel-btn"
            :disabled="isSendingRequest"
            @click="userAssignDialogVisible = false"
          >
            キャンセル
          </el-button>
          <el-button
            class="blue-text-btn"
            :loading="isSendingRequest"
            @click="assignUser()"
          >
            割り当てる
          </el-button>
        </span>
      </el-dialog>

      <!-- 注文管理 -->
      <el-dialog
        :visible.sync="orderManagementDialogVisible"
        width="70%"
        center
      >
        <div
          class="order-management-dialog-body"
          v-loading="orderManagementLoading"
        >
          <span class="dialog-text">戒名の一覧</span>
          <div class="order-management-list u-pb20">
            <div
              v-for="managedOrder in managedOrders"
              :key="managedOrder.id"
              class="order-management-item"
            >
              <div
                class="order-management-preview-frame u-mb10"
                :class="{
                  'order-management-preview-frame--current':
                    isDisplayedManagedOrderInManagementModal(managedOrder),
                }"
              >
                <TabletPreview
                  :order="managedOrder"
                  :frontColor="(managedOrder.fontColors && managedOrder.fontColors[1]) || { name: '金色', colorCode: 'yellow' }"
                  :backColor="(managedOrder.fontColors && managedOrder.fontColors[0]) || { name: '白', colorCode: 'white' }"
                  :is-show-description="false"
                />
              </div>
              <el-button
                type="primary"
                class="u-mt10"
                @click="onClickShowManagedOrder(managedOrder.id)"
              >
                表示する
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="customerDialog">
      <!-- edit customer dialog -->
      <el-dialog
        :visible.sync="editDialog"
        :close-on-click-modal="!isSendingRequest"
        width="40%"
      >
        <el-form>
          <table class="adminOrderDetailTable">
            <tr>
              <th class="adminOrderDetailTable-th" colspan="2">お客様情報</th>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">お名前</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.name"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">郵便番号</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.zipcode"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">住所</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.address"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">電話番号</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.tel"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">宗派</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-select
                    @change="changeSect($event)"
                    :value="sect"
                    placeholder="宗派"
                  >
                    <div
                      v-for="(sectList, index) in SECT_LIST"
                      v-bind:key="index"
                    >
                      <el-option :value="sectList">{{ sectList }}</el-option>
                    </div>
                  </el-select>
                </el-form-item>
                <el-form-item label="" prop="" v-if="sectIsEtc === true">
                  <el-input
                    placeholder="宗派を入力"
                    v-model="customerItems.customer.sect"
                    class="e-input"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">菩提寺</td>
              <td class="adminOrderDetailTable-td">
                <el-form-item>
                  <el-input
                    v-model="customerItems.customer.familyTemple"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="adminOrderDetailTable-td">備考</td>
              <td class="adminOrderDetailTable-td Note">
                <el-form-item>
                  <el-input
                    :autosize="{ minRows: 2, maxRows: 100 }"
                    type="textarea"
                    v-model="customerItems.customer.note"
                    @keyup.enter.native="updateOrder()"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>

        <span>
          <el-button
            id="btnText"
            type="text"
            :disabled="isSendingRequest"
            @click="onCancelUpdate()"
          >
            キャンセル
          </el-button>
        </span>
        <span>
          <el-button
            id="btnText"
            type="text"
            :loading="isSendingRequest"
            @click="updateOrder()"
          >
            保存する
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import Order from "@/entities/order.entity";
import SECT_LIST from "../../const/sectList.js";

import TabletPreview from "@/components/Common/TabletPreview.vue";
import AdminOrderDetailRodanSetValues from "@/components/Admin/OrderDetail/RodanSetValues.vue";
import InformationTable from "@/components/InformationTable";
import AdminOrdersImageUploader from "@/components/Admin/Orders/ImageUploader";
import SignatureInput from "@/components/SignatureInput";

import OrderUsecase from "@/usecases/order.usecase";
import FileUsecase from "@/usecases/file.usecase";
// import VariantCharacterUsecase from "@/usecases/variantCharacter.usecase";
// import SanskritCharacterUsecase from "@/usecases/sanskritcharacter.usecase";
import UserUsecase from "@/usecases/user.usecase";

// import FamilyEmblemService from "@/services/familyEmblem.service";
import SanskritCharacterService from "@/services/sanskritCharacter.service";
import { apiErrorHandler } from "@/services/apiErrorHandler";

// 注文ステータス [納期確認, レイアウト作成, レイアウト調整, 注文確定, 発送済み]
const ORDER_STATUS = [
  "PROCESSING",
  "PROCESSING_CREATING_LAYOUT",
  "REVISING_LAYOUT",
  "CONFIRMED",
  "SHIPPED",
];

export default {
  components: {
    TabletPreview,
    AdminOrderDetailRodanSetValues,
    InformationTable,
    SignatureInput,
    AdminOrdersImageUploader,
  },
  data () {
    return {
      order: {},
      basicInformations: [],
      customerItems: {
        customer: {
          name: "",
          zipcode: "",
          address: "",
          tel: "",
          sect: "",
          familyTemple: "",
          note: "",
        },
      },
      sectIsEtc: false,
      sect: "",
      customFamilyEmblemImg: "",
      customSanskritCharacterImg: "",
      customSanskritCharacterBackImg: "",
      sects: [],
      productInformations: [],
      users: [],
      userAssignDialogVisible: false,
      assignName: "",
      selectUserName: "",
      selectUserId: "",
      orderDetailId: null,
      editDialog: false,
      isDisableLayoutCreating: false,
      isDisableLayoutAdjust: false,
      isDisableOrder: false,
      isDisableShipped: false,
      layoutCreatingDialogVisible: false,
      layoutAdjustDialogVisible: false,
      dateInputDialogVisible: false,
      confirmOrderDialogVisible: false,
      printApprovalSetDialogVisible: false,
      shippedDialogVisible: false,
      fixedShippingDate: "",
      orderStatus: "",
      selectedValue: "対応を選択",
      acceptOrderDialogVisible: false,
      cancelOrderDialogVisible: false,
      isLayoutVisible: false,
      isOrderVisible: false,
      isShippedVisible: false,
      isArrow1Visible: false,
      isArrow2Visible: false,
      isNeededLayoutReply: "",
      isShowRodanSetValues: false,
      points: [],
      buddhistNames: ["", ""],
      secularNames: ["", ""],
      diedCharacter: ["", ""],
      dateOfDeath: ["", ""],
      dateOfDeathYear: ["", ""],
      dateOfDeathDay: ["", ""],
      ageAtDeath: ["", ""],
      ageAtDeathPrefix: ["", ""],
      underCharacters: ["", ""],
      secularNameSuffix: ["", ""],
      ageUnitCharacter: ["", ""],
      secularNamePrefix: ["", ""],
      commonAgeAtDeathPrefix: "",
      commonSecularNamePrefix: "",
      commonDiedCharacter: "",
      commonAgeUnitCharacter: "",
      commonUnderCharacters: "",
      // 「レイアウト調整を開始する」のフィルアップロード用
      images: [],
      isSendingRequest: false,
      isUploadingFile: false,
      isLoading: false,
      primaryOrderData: null,
      orderManagementDialogVisible: false,
      orderManagementLoading: false,
      orderManagementOrders: [],
      // Layout Image management
      showLayoutManagement: true,
      layoutImagesResolved: [],
      adminLayoutImageDialogVisible: false,
      adminSelectedLayoutImage: null,
    };
  },
  title () {
    return "戒名発注アプリ nanokos";
  },
  async created () {
    window.scrollTo(0, 0);
    this.syncOrder();
    this.getPointsImages();
    this.getSects();
    this.getCustomImg();
    // this.getOrderSect();
  },
  mounted () {},
  watch: {
    "$route.params.id": function () {
      this.syncOrder();
    },
    editDialog: async function () {
      if (!this.editDialog) {
        this.onCancelUpdate();
      }
    },
    order: {
      deep: true,
      handler: function () {
        this.getPointsImages();
        this.loadLayoutImagesAdmin();
      },
    },
  },
  computed: {
    computedStepByOrderStatus () {
      const { orderStatus } = this;
      const step = ORDER_STATUS.indexOf(orderStatus);

      return step;
    },
    SECT_LIST () {
      return SECT_LIST.sects;
    },
    isValidOrderAvailable () {
      return this.order instanceof Order;
    },
    primaryOrder () {
      const src = this.primaryOrderData;
      if (src && src.id) {
        return src;
      }
      return this.order;
    },
    managedOrders () {
      return this.orderManagementOrders;
    },
    buttonGroup () {
      this.getCustomImg();
      return this.order.buttonGroup;
    },
    allLayoutImages () {
      if (!this.order || !this.order.layoutImages) return [];
      return this.order.layoutImages;
    },
    hasApprovedLayoutImage () {
      return this.allLayoutImages.some(img => img.isApproved);
    },
    approvedLayoutImage () {
      return this.layoutImagesResolved.find(img => img.isApproved) || null;
    },
    isStatusConfirmedOrLater () {
      // orderStatus (data) と order.status.code (computed source) 両方チェック
      const code = this.orderStatus || (this.order && this.order.status && this.order.status.code);
      return code === "CONFIRMED" || code === "SHIPPED";
    },
    /* to get 注文を確定する button class action */
    getConfirmClass () {
      if (!this.isNeededLayoutReply) {
        if (this.orderStatus === "PROCESSING") {
          return "";
        } else if (this.orderStatus === "CONFIRMED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      } else {
        if (this.orderStatus === "PROCESSING") {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "REVISING_LAYOUT") {
          return "";
        } else if (this.orderStatus === "CONFIRMED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      }
    },
    /* to get 発送済みにする button class action */
    getShippedClass () {
      if (!this.isNeededLayoutReply) {
        if (this.orderStatus === "PROCESSING") {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "CONFIRMED") {
          return "";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else {
          return "";
        }
      } else {
        if (
          this.orderStatus === "PROCESSING" ||
          this.orderStatus === "REVISING_LAYOUT"
        ) {
          return "bggray-colorwhite";
        } else if (this.orderStatus === "SHIPPED") {
          return "bggray-colorblack";
        } else if (this.orderStatus === "CONFIRMED") {
          return "";
        } else {
          return "";
        }
      }
    },
  },
  methods: {
    /**
     * fetch type attribute value for el-button
     * @param   {number}  applicableStep  [applicableStep description]
     * @return  {string}                  [return description]
     */
    fetchTypeByStep (applicableStep) {
      const { computedStepByOrderStatus } = this;

      if (applicableStep === computedStepByOrderStatus) {
        return "primary";
      }

      return "info";
    },

    /**
     * fetch disabled attribute value for el-button
     * @param   {array}  steps  [steps description]
     * @return  {boolean}       isDisabled
     */
    fetchIsDisabledBySteps (steps) {
      const { computedStepByOrderStatus } = this;
      const isDisabled = steps.some(step => step === computedStepByOrderStatus);

      return isDisabled;
    },
    async getCustomImg () {
      if (
        this.order &&
        this.order.detail &&
        this.order.detail.customFamilyEmblemUrl
      ) {
        this.customFamilyEmblemImg = await usecase.file.fetchURL(
          this.order.detail.customFamilyEmblemUrl
        );
      }
      if (
        this.order &&
        this.order.detail &&
        this.order.detail.customSanskritCharacterUrl
      ) {
        this.customSanskritCharacterImg = await usecase.file.fetchURL(
          this.order.detail.customSanskritCharacterUrl
        );
      }
      if (
        this.order &&
        this.order.detail &&
        this.order.detail.customSanskritCharacterBackUrl
      ) {
        this.customSanskritCharacterBackImg = await usecase.file.fetchURL(
          this.order.detail.customSanskritCharacterBackUrl
        );
      }
    },
    async getSects () {
      try {
        this.sects = await sanskritCharacterService.getSankritCharacters();
        this.sects = this.sects.data.sanskritCharacters;
        this.sects.push({
          id: "sc-etc",
          imageUrl: "",
          imageUrlForTablet: "",
          sect: "その他",
        });
      } catch (err) {
        apiErrorHandler(this, err);
      }
    },
    changeSect (event) {
      this.sect = event;
      if (event === "その他") {
        this.sectIsEtc = true;
        this.customerItems.customer = {
          ...this.customerItems.customer,
          sect: "",
        };
      }
      if (event !== "その他") {
        this.sectIsEtc = false;
        this.customerItems.customer = {
          ...this.customerItems.customer,
          sect: event,
        };
      } else {
        this.sectIsEtc = true;
      }
    },
    getPointsImages () {
      if (!this.order.itaijiPoints) {
        return;
      }
      this.points = [];
      this.order.itaijiPoints.map(key => {
        return usecase.file.fetchURL(key).then(url => {
          this.points.push(url);
        });
      });
    },
    async syncOrder () {
      if (!this.$route.params.id) return;
      const orderId = this.$route.params.id;
      this.orderDetailId = orderId;
      this.isLoading = true;
      try {
        this.order = await usecase.order.getOrder({ orderId });
        this.primaryOrderData = await this.loadPrimaryOrder(this.order);
        // 宗派でその他が選択されている場合のチェック
        let count = SECT_LIST.sects.length;
        // 取得した宗派リストと客の宗派を比較
        for (let i = 0; i < count; i++) {
          if (this.order.customer.sect === "その他") {
            this.sectIsEtc = true;
            this.sect = "その他";
            break;
          } else if (SECT_LIST.sects[i] === this.order.customer.sect) {
            this.sectIsEtc = false;
            this.sect = this.order.customer.sect;
            break;
          } else {
            this.sectIsEtc = true;
            this.sect = "その他";
          }
        }
        if (this.order) {
          this.fixedShippingDate = this.order.detail.fixedShippingDate;
          this.orderStatus = this.order.status.code;
          this.showLayoutManagement = this.orderStatus !== "CONFIRMED" && this.orderStatus !== "SHIPPED";
          this.isNeededLayoutReply = this.order.detail.isNeededLayoutReply;
          this.getButtonsAction();
          this.getBasicInformations(this.order);
          // this.getProductInformations(this.order);
          if (this.order.staff !== null) {
            this.assignName = this.order.staff.name;
          }
          const query = {
            q: { role: "ADMIN" },
          };
          this.users = await usecase.user.getAdminUsers(query);
        }
      } catch (err) {
        apiErrorHandler(this, err);
      }

      // 商品明細を取得する
      if (!this.order.parentOrder) {
        try {
          const res = await usecase.order.getKikanOrderDetail({ orderId });
          const { kikanOrderDetail } = res.data;

          // 明細の項目を作る
          const rows = Object.keys(kikanOrderDetail)
            .map(key => {
              if (
                typeof kikanOrderDetail[key] === "object" &&
                kikanOrderDetail[key] !== null
              ) {
                // 通常の行として追加する
                return {
                  ...kikanOrderDetail[key],
                };
              }
              return null;
            })
            .filter(o => o);

          // サマリの行を作る
          if (rows.length > 0) {
            const { note, subtotal, tax, total } = this.createSummaries(kikanOrderDetail);

            rows.push(...[note, subtotal, tax, total]);
          }

          this.productInformations = rows;
        } catch (err) {
          apiErrorHandler(this, err);
        }
      }

      try {
        this.setBtnVisible();
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.isLoading = false;
        this.isShowRodanSetValues = true;
      }
    },

    /**
     * [createSummaries description]
     * @param   {[type]}  kikanOrderDetail  [kikanOrderDetail description]
     * @return  {[type]}                    [return description]
     */
    createSummaries (kikanOrderDetail) {
      const fetchSummary = (kikanOrderDetail) => (key, quantity) => {
        const price = kikanOrderDetail[key] || null;
        const summary = {
          index: "",
          id: "",
          note: "",
          orderId: "",
          price,
          productVariationId: "",
          productName: "",
          quantity,
          unitPrice: "",
        };

        return summary;
      };

      const note = fetchSummary(kikanOrderDetail)("remarks", "備考");
      const subtotal = fetchSummary(kikanOrderDetail)("subtotal", "小計");
      const tax = fetchSummary(kikanOrderDetail)("taxTotal", "消費税");
      const total = fetchSummary(kikanOrderDetail)("total", "合計");
      const summaries = {
        note,
        subtotal,
        tax,
        total,
      };

      return summaries;
    },

    // set buttons are disable or enable condition
    setBtnVisible () {
      if (!this.isNeededLayoutReply) {
        if (
          this.orderStatus === "PROCESSING" ||
          this.orderStatus === "PROCESSING_CREATING_LAYOUT"
        ) {
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "CONFIRMED") {
          this.isDisableOrder = true;
          this.isDisableShipped = false;
        } else if (this.orderStatus === "SHIPPED") {
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        }
      } else {
        if (this.orderStatus === "PROCESSING") {
          this.isDisableLayoutCreating = false;
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "PROCESSING_CREATING_LAYOUT") {
          this.isDisableLayoutCreating = true;
          this.isDisableLayoutAdjust = false;
          this.isDisableOrder = true;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "REVISING_LAYOUT") {
          this.isDisableLayoutCreating = false;
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        } else if (this.orderStatus === "CONFIRMED") {
          this.isDisableLayoutCreating = true;
          this.isDisableLayoutAdjust = false;
          this.isDisableOrder = true;
          this.isDisableShipped = false;
        } else if (this.orderStatus === "SHIPPED") {
          this.isDisableLayoutAdjust = true;
          this.isDisableOrder = false;
          this.isDisableShipped = true;
        }
      }
    },
    /* to get (レイアウト調整を開始する、注文を確定する, 発送済みにする)button action */
    async getButtonsAction () {
      await this.getButtonVisible();
    },
    /* to show/hide (レイアウト調整を開始する、注文を確定する,発送済みにする)action */
    getButtonVisible () {
      if (this.isNeededLayoutReply) {
        this.isLayoutVisible = true;
        this.isOrderVisible = true;
        this.isShippedVisible = true;
        this.isArrow1Visible = true;
        this.isArrow2Visible = true;
      } else {
        this.isLayoutVisible = false;
        this.isOrderVisible = true;
        this.isShippedVisible = true;
        this.isArrow1Visible = false;
        this.isArrow2Visible = true;
      }
    },
    /* to get basic informations */
    getBasicInformations (order) {
      let orderDate = "";
      let orderedAtDate = order.orderedAt;
      let expectedShippingDate = order.detail.expectedShippingDate;
      let fixedShippingDate = order.detail.fixedShippingDate;
      if (orderedAtDate) {
        orderDate = moment
          .unix(String(orderedAtDate))
          .format("YYYY/MM/DD  HH:mm");
      }
      let layout = order.detail.isNeededLayoutReply === true ? "有" : "無";
      this.basicInformations = [
        ["注文番号", order.orderNumber],
        ["受注日", orderDate],
        ["ステータス", order.status.name],
        ["レイアウト調整の有無", layout],
        [
          "希望納期",
          expectedShippingDate ? expectedShippingDate.replace(/-/g, "/") : "",
        ],
        ["送り状番号", ""],
        [
          "出荷日",
          fixedShippingDate ? fixedShippingDate.replace(/-/g, "/") : "",
        ],
        [
          "得意先",
          order.client && order.client.clientGroup
            ? order.client.clientGroup.name
            : "[得意先無し]",
        ],
        [
          "得意先担当者",
          order.client ? order.client.name : "[削除されたユーザー]",
        ],
      ];
    },
    /* to go back to admin order list home screen */
    gotoHome () {
      const { $router } = this;
      $router.push({
        path: "/admin/home",
      });
    },
    /* to span column for remark */
    arraySpanMethod ({ rowIndex, columnIndex }) {
      let rolNo =
        this.order.statement && this.order.statement.items.length
          ? this.order.statement.items.length
          : "";
      if (rowIndex === rolNo) {
        if (columnIndex === 5) {
          return [1, 3];
        }
      }
    },
    /* to open accept request order dialog */
    getAcceptRequestDialog () {
      this.acceptOrderDialogVisible = true;
    },
    /* to accept request order */
    _onClickAcceptOrder () {
      this.updateStatus("DRAFT");
      this.acceptOrderDialogVisible = false;
    },
    /* to open cancel request order dialog */
    getCancelRequestDialog () {
      this.cancelOrderDialogVisible = true;
    },
    /* to cancel request order */
    _onClickCancelOrder () {
      this.updateStatus("PROCESSING");
      this.cancelOrderDialogVisible = false;
    },
    /* to update order status by DRAFT and PROCESSING status */
    async updateStatus (status) {
      const orderId = this.$route.params.id;
      const updateStatus = {
        orderId: orderId,
        status: status,
      };

      try {
        this.isSendingRequest = true;

        // update it
        await usecase.order.orderUpdateStatus(updateStatus);

        // it succeed, so I notify it
        this.$notify({
          message:
            status === "DRAFT"
              ? "注文のキャンセルを行いました。"
              : "注文のキャンセルを取り消しました。",
          duration: 3000,
        });

        // return home
        this.gotoHome();
      } catch (err) {
        apiErrorHandler(this, err);
        return;
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to change user assign option */
    changeAssignOption (event) {
      this.selectUserName = event.name;
      this.selectUserId = event.id;
      this.userAssignDialogVisible = true;
    },
    /* to assign user */
    async assignUser () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const staffId = this.selectUserId;
      const staffName = this.selectUserName;
      const updateStaff = {
        orderId,
        staffId,
      };

      try {
        this.isSendingRequest = true;

        // update it
        await usecase.order.orderAssignStaff(updateStaff);

        // close modal
        this.userAssignDialogVisible = false;

        // set assign name
        this.assignName = staffName;
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* go to order's message screen */
    _onClickOrderMessage () {
      const primaryId = this.getPrimaryOrderId();
      if (!primaryId) {
        return;
      }
      const viewId = this.$route.params.id;
      const { $router } = this;
      if (viewId != null && String(viewId) !== String(primaryId)) {
        $router.push({
          path: `/admin/orders/${primaryId}/messages`,
          query: { returnTo: String(viewId) },
        });
        return;
      }
      $router.push(`/admin/orders/${primaryId}/messages`);
    },
    /* to open edit customer dialog */
    goToEdit () {
      this.editDialog = true;
      this.customerItems = JSON.parse(JSON.stringify(this.order));
    },
    /* to update customer informations of order */
    async updateOrder () {
      const name = this.customerItems.customer.name;
      const zipcode = this.customerItems.customer.zipcode;
      const address = this.customerItems.customer.address;
      const tel = this.customerItems.customer.tel;
      const familyTemple = this.customerItems.customer.familyTemple;
      const sect = this.customerItems.customer.sect;
      const note = this.customerItems.customer.note;
      const orderId = this.$route.params.id;
      const param = {
        orderId,
        order: {
          customer: {
            name: name,
            zipcode: zipcode,
            address: address,
            tel: tel,
            familyTemple: familyTemple,
            sect: sect,
            note: note,
          },
        },
      };

      try {
        this.isSendingRequest = true;

        // update it
        await usecase.order.orderUpdate(param);

        // close modal
        this.editDialog = false;

        // it succeed, so I notify it
        this.$notify({
          message: "お客様情報を更新しました。",
          duration: 3 * 1000,
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to cancel customer update */
    onCancelUpdate () {
      this.$store.commit("orderForm/init");
      this.editDialog = false;
      this.customerItems.customer.name = this.order.customerInformation[0][1];
      this.customerItems.customer.zipcode = this.order.customerInformation[1][1];
      this.customerItems.customer.address = this.order.customerInformation[2][1];
      this.customerItems.customer.tel = this.order.customerInformation[3][1];
      this.customerItems.customer.sect = this.order.customerInformation[4][1];
      this.customerItems.customer.familyTemple = this.order.customerInformation[5][1];
      this.customerItems.customer.note = this.order.customerInformation[6][1];
      this.customerItems.customer.attachments = this.order.customerInformation[7][1];
    },
    /* to update order by status=REVISING_LAYOUT */
    async startLayoutCreating () {
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusLayoutCreating();

        // close modal
        this.layoutCreatingDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "レイアウト作成を開始しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusLayoutCreating () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "PROCESSING_CREATING_LAYOUT",
      };
      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    /* to update order by status=REVISING_LAYOUT */
    async startLayoutAdjust () {
      let message = "";
      if (this.orderStatus === "PROCESSING_CREATING_LAYOUT") {
        try {
          this.isSendingRequest = true;

          // update it
          await this.updateOrderStartLayoutRevision();

          // clear input for image file
          this.$refs.adminOrdersImageUploader.initImageFiles();

          // close modal
          this.layoutAdjustDialogVisible = false;
          // it succeed, so I notify it
          message = "レイアウト調整を開始しました。";
          this.$notify({ message });
          // to get order update list
          this.syncOrder();
        } catch (err) {
          alert(err.errors[0].message);
        } finally {
          this.isSendingRequest = false;
        }
        return;
      }
      // レイアウト調整開始に戻す時
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusLayoutAdjust();

        // close modal
        this.layoutAdjustDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "レイアウト調整を開始しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order from PROCESSING to REVISING_LAYOUT */
    async updateOrderStartLayoutRevision () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const image = Array.isArray(this.images) && this.images.length > 0
        ? this.images[0]
        : null;
      const OrderUpdateInputParam = {
        orderId: orderId,
        image,
      };
      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderStartLayoutRevision(OrderUpdateInputParam);
        return res;
      }
    },
    /* to update order, save order update information */
    async updateStatusLayoutAdjust () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "REVISING_LAYOUT",
      };
      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    /* to open layout creating order dialog */
    _onClickLayoutCreating () {
      const { orderStatus } = this;

      if (this.isDisableLayoutCreating) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため
      if (
        orderStatus === "PROCESSING" ||
        orderStatus === "REVISING_LAYOUT"
      ) {
        this.layoutCreatingDialogVisible = true;
      }
    },
    /* to open layout adjust order dialog */
    _onClickLayoutAdjust () {
      const { orderStatus } = this;

      if (this.isDisableLayoutAdjust) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため
      if (
        orderStatus === "PROCESSING_CREATING_LAYOUT" ||
        orderStatus === "CONFIRMED"
      ) {
        this.layoutAdjustDialogVisible = true;
      }
    },
    /* to open delivery date input dialog */
    _onClickConfirmOrder () {
      const { orderStatus } = this;

      if (this.isDisableOrder) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため念の為
      if (orderStatus === "REVISING_LAYOUT") {
        this.fixedShippingDate = "";
        this.dateInputDialogVisible = true;
      } else if (orderStatus === "SHIPPED") {
        this.confirmOrderDialogVisible = true;
      }
    },
    /* to open shipped order dialog */
    _onClickShippedOrder () {
      const { orderStatus } = this;

      if (this.isDisableShipped) {
        return;
      }

      // ここの条件はなくても良いかもしれないが
      // isNeededLayoutReply などの不明な値があるため念の為
      if (orderStatus === "CONFIRMED") {
        this.shippedDialogVisible = true;
      }
    },
    /* to open confirm order dialog */
    _onClickShippingDateOK () {
      if (this.isDisableOrder) {
        return false;
      } else {
        this.confirmOrderDialogVisible = true;
        setTimeout(() => {
          this.dateInputDialogVisible = false;
        }, 100);
      }
    },
    /* to cancel start layout creating, close layout start dialog  */
    cancelLayoutCreating () {
      this.layoutCreatingDialogVisible = false;
    },
    /* to cancel start layout, close layout start dialog  */
    cancelLayoutAdjust () {
      this.layoutAdjustDialogVisible = false;
    },
    /* to cancel delivery date input, close date input dialog  */
    cancelDateInput () {
      this.dateInputDialogVisible = false;
      this.fixedShippingDate = this.order.detail.fixedShippingDate;
    },
    /* to cancel confirm order, close confirm order dialog */
    cancelConfirmOrder () {
      this.confirmOrderDialogVisible = false;
      this.dateInputDialogVisible = false;
    },
    /* to update fixedShippingDate and status of order by CONFIRMED */
    async _onClickConfirm () {
      const { orderStatus } = this;

      try {
        this.isSendingRequest = true;

        // update it
        if (orderStatus === "SHIPPED") {
          // ステータスだけ変更
          await this.updateStatusConfirmedWithoutShippingDate();
        } else {
          await this.updateStatusConfirmed();
        }

        // close modal
        this.confirmOrderDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "注文を確定しました。",
        });

        // to get order update list
        this.syncOrder();

        // 「レイアウト調整」→「注文確定」時は校了セット印刷確認を表示
        if (orderStatus === "REVISING_LAYOUT") {
          this.printApprovalSetDialogVisible = true;
        }
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusConfirmed () {
      this.dateInputDialogVisible = false;
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const orderParam = {
        status: "CONFIRMED",
        detail: {
          fixedShippingDate: this.getShippingDate(this.fixedShippingDate),
        },
      };
      const OrderUpdateInputParam = {
        orderId: orderId,
        order: orderParam,
      };
      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderUpdate(OrderUpdateInputParam);
        return res;
      }
    },

    /* to update order, save order update information without fixedShippingDate */
    async updateStatusConfirmedWithoutShippingDate () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId,
        status: "CONFIRMED",
      };

      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },

    /* to update order by SHIPPED order status */
    async _onClickShipped () {
      try {
        this.isSendingRequest = true;

        // update it
        await this.updateStatusShipped();

        // close modal
        this.shippedDialogVisible = false;

        // it succeed, so I notify it
        this.$notify({
          message: "注文を発送しました。",
        });

        // to get order update list
        this.syncOrder();
      } catch (err) {
        alert(err.errors[0].message);
      } finally {
        this.isSendingRequest = false;
      }
    },
    /* to update order, save order update information */
    async updateStatusShipped () {
      const orderId = this.getPrimaryOrderId();
      if (!orderId) {
        return;
      }
      const OrderUpdateInputParam = {
        orderId: orderId,
        status: "SHIPPED",
      };
      if (OrderUpdateInputParam) {
        const res = await usecase.order.orderUpdateStatus(OrderUpdateInputParam);
        return res;
      }
    },
    /* to get shipping date format */
    getShippingDate (shipDate) {
      var date = new Date(shipDate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dt = date.getDate();
      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return shipDate ? year + "-" + month + "-" + dt : "";
    },
    /* to print for admin order information */
    printOrder () {
      window.print();
    },
    async onClickPrintOrderPreview (id) {
      const { $router } = this;
      this.$store.commit("orderForm/setOrderId", id);
      $router.push(`/admin/orderPrintPreview/${id}/${this.order.orderNumber}`);
    },
    async loadPrimaryOrder (currentOrder) {
      if (!currentOrder || !currentOrder.id) {
        return null;
      }
      const parentOrderId =
        currentOrder.parentOrder && currentOrder.parentOrder.id
          ? currentOrder.parentOrder.id
          : currentOrder.id;
      const primaryOrder =
        parentOrderId === currentOrder.id
          ? currentOrder
          : await usecase.order.getOrder({ orderId: parentOrderId });
      if (!primaryOrder) {
        return null;
      }
      return primaryOrder instanceof Order ? primaryOrder : Order.fromJson(primaryOrder);
    },
    getPrimaryOrderId () {
      return this.primaryOrder && this.primaryOrder.id
        ? this.primaryOrder.id
        : null;
    },
    async loadOrderManagementOrders () {
      const currentOrderId = this.$route.params.id;
      if (!currentOrderId) {
        return [];
      }

      const fromDetail =
        this.order &&
        this.order.id &&
        String(this.order.id) === String(currentOrderId)
          ? this.order
          : null;

      const currentOrder =
        fromDetail || (await usecase.order.getOrder({ orderId: currentOrderId }));
      if (!currentOrder) {
        return [];
      }

      const parentOrder = await this.loadPrimaryOrder(currentOrder);
      if (!parentOrder) {
        return [];
      }

      const childOrders = Array.isArray(parentOrder.childOrders)
        ? parentOrder.childOrders
        : [];
      return [parentOrder, ...childOrders].map(order =>
        order instanceof Order ? order : Order.fromJson(order)
      );
    },
    async openOrderManagementDialog () {
      this.orderManagementDialogVisible = true;
      this.orderManagementLoading = true;
      try {
        this.orderManagementOrders = await this.loadOrderManagementOrders();
      } finally {
        this.orderManagementLoading = false;
      }
    },
    async onClickShowManagedOrder (orderId) {
      if (!orderId) {
        return;
      }
      if (orderId === this.$route.params.id) {
        this.orderManagementDialogVisible = false;
        return;
      }
      this.$router.push(`/admin/orders/${orderId}`);
      this.orderManagementDialogVisible = false;
    },
    isDisplayedManagedOrderInManagementModal (managedOrder) {
      const currentOrderId =
        (this.order && this.order.id) || this.$route.params.id;
      return (
        currentOrderId != null &&
        String(currentOrderId) === String(managedOrder.id)
      );
    },
    getStringWithoutVariantCharacterCode (item) {
      let result = "";
      if (
        this.order.detail &&
        this.order.detail.columns &&
        item &&
        item.length
      ) {
        const valueDatas = item;
        const resultCharacters = [];
        for (const characterData of valueDatas) {
          resultCharacters.push(characterData.character);
        }
        result = resultCharacters.join("");
      }
      return result;
    },
    // 使ってない?
    getStingArrayWithoutVariantCharacterCode (item) {
      const results = [];
      if (this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          const stringDatas = this.order.detail.columns[i][item];
          const value = this.getStringWithoutVariantCharacterCode(stringDatas);
          results.push(value);
        }
      }
      return results;
    },
    // 使ってない?
    getColumnsInformationValue (itemName, num) {
      const items = this.order.columnsInformation2;
      if (items && items.length > num) {
        let result = "";
        if (items) {
          items[num].forEach(value => {
            if (value[0] === itemName) {
              result = value[1];
            }
          });
        }
        return result;
      }
      return "";
    },
    // 使ってない?
    getDetailInformationValue (ItemName) {
      const items = this.order.detailInformation2;
      let result = "";
      if (items) {
        items.forEach(value => {
          if (value[0] === ItemName) {
            result = value[1];
          }
        });
      }
      return result;
    },
    // 使ってない?
    getDateOfDeathYear (num) {
      if (
        this.dateOfDeath &&
        this.dateOfDeath.length &&
        this.dateOfDeath.length > num
      ) {
        const datesOfDeath = this.dateOfDeath[num];
        if (datesOfDeath) {
          const index = datesOfDeath.indexOf("年");
          if (index === 0) return "";
          return datesOfDeath.toString().substr(0, index + 1);
        }
      }
      return "";
    },
    // 使ってない?
    getDateOfDeathDate (num) {
      if (
        this.dateOfDeath &&
        this.dateOfDeath.length &&
        this.dateOfDeath.length > num
      ) {
        const datesOfDeath = this.dateOfDeath[num];
        if (datesOfDeath) {
          const index = datesOfDeath.indexOf("年");
          if (index === 0) return "";
          return datesOfDeath.slice(index + 1);
        }
      }
      return "";
    },
    isAttachments (item) {
      return Array.isArray(item);
    },
    updateImageFile (imageKey) {
      this.images.push(imageKey);
    },

    /**
     * [updateIsUploadingFile description]
     * @param   {[type]}  isUploadingFile  [isUploadingFile description]
     */
    updateIsUploadingFile (isUploadingFile) {
      this.isUploadingFile = isUploadingFile;
    },

    // Layout Image Admin Methods
    async loadLayoutImagesAdmin () {
      const order = this.order;
      if (!order || !order.layoutImages || !order.layoutImages.length) {
        this.layoutImagesResolved = [];
        return;
      }
      const images = await Promise.all(
        order.layoutImages.map(async (img) => {
          let resolvedUrl = "";
          try {
            resolvedUrl = await usecase.file.fetchURL(img.imageKey);
          } catch (e) {
            console.error("Failed to resolve layout image URL:", e);
          }
          return { ...img, resolvedUrl };
        })
      );
      this.layoutImagesResolved = images;
    },
    openAdminLayoutImageDialog (img) {
      this.adminSelectedLayoutImage = img;
      this.adminLayoutImageDialogVisible = true;
    },
    async onLayoutImageFileSelected (file) {
      const { raw, name } = file;
      // Validate file size (3MB)
      if (raw.size > 3 * 1024 * 1024) {
        alert("ファイルサイズは3MB以内にしてください。");
        return;
      }
      try {
        const category = "layoutImage";
        const fileName = usecase.file.fetchFileName(name, category);
        const result = await usecase.file.uploadFile(fileName, raw);
        // Add layout image via API
        await usecase.order.addLayoutImage({
          orderId: this.order.id,
          image: result.key,
          fileName: name,
        });
        this.syncOrder();
      } catch (err) {
        alert("レイアウト画像のアップロードに失敗しました。");
        console.error(err);
      }
    },
    async removeLayoutImage (img) {
      if (!confirm(`レイアウト画像「${img.fileName || img.imageKey}」を削除しますか？`)) return;
      try {
        await usecase.order.removeLayoutImage({
          orderId: this.order.id,
          layoutImageId: img.id,
        });
        this.syncOrder();
      } catch (err) {
        alert("レイアウト画像の削除に失敗しました。");
        console.error(err);
      }
    },
    async unapproveAllLayoutImages () {
      if (!confirm("校了を取り消しますか？")) return;
      try {
        for (const img of this.allLayoutImages) {
          if (img.isApproved) {
            await usecase.order.unapproveLayoutImage({
              orderId: this.order.id,
              layoutImageId: img.id,
            });
          }
        }
        this.syncOrder();
      } catch (err) {
        alert("校了の取り消しに失敗しました。");
        console.error(err);
      }
    },
    printApprovalSet () {
      this.printApprovalSetDialogVisible = false;
      const { $router } = this;
      const orderId = this.order.id;
      const orderNumber = this.order.orderNumber;
      this.$store.commit("orderForm/setOrderId", orderId);
      $router.push(`/admin/approvalSetPrint/${orderId}/${orderNumber}`);
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.order = new OrderUsecase();
    usecase.user = new UserUsecase();
    // usecase.variantCharacter = new VariantCharacterUsecase();
    // usecase.sanskritCharacter = new SanskritCharacterUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
// const familyEmblemService = new FamilyEmblemService();
const sanskritCharacterService = new SanskritCharacterService();
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

@media print {
  * {
    -webkit-print-color-adjust: exact !important; /*Chrome, Safari */
    color-adjust: exact !important; /*Firefox*/
  }
  @page {
    size: portrait;
    margin-top: 20mm;
    margin-bottom: 20mm;
    margin-left: -40mm;
    margin-right: 0;
  }
  @page :first {
    size: portrait;
    margin-top: 8mm;
    margin-bottom: 20mm;
    margin-left: -40mm;
    margin-right: 0;
  }
  #HomeStyle {
    display: none;
  }
  #editBtn {
    display: none;
  }
  #sidebar {
    display: none;
  }
  #hideButton1 {
    display: none;
  }
  #hideButton2 {
    display: none;
  }
  .Flow {
    overflow: hidden !important;
    height: auto !important;
  }
  /* For preview table */
  #preview {
    page-break-before: always;
  }
  #typography {
    page-break-before: always;
  }
  #columnData {
    page-break-before: always;
  }
  #printAdmin .el-table__header-wrapper th {
    border-top: 0.1px solid $--border-color-lighter !important;
    border-left: 0.1px solid $--border-color-lighter !important;
  }
  #printAdmin .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto !important;
  }
  #printAdmin .el-table__body {
    width: 107% !important;
  }
}
.bggray-colorwhite {
  display: inline-block;
  line-height: 1;
  color: white !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: $background-gray-deep !important;
  padding: 12px 20px !important;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid $blue-extra-deep !important;
  white-space: nowrap;
  -webkit-appearance: none;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;
}
.bggray-colorblack {
  display: inline-block;
  line-height: 1;
  color: $text-lighter !important;
  background-image: none !important;
  background-color: $background-gray-deep !important;
  padding: 12px 20px !important;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid $blue-extra-deep !important;
  white-space: nowrap;
  -webkit-appearance: none;
  transition: 0.1s;
  font-weight: 500;
  font-size: 14px;

  &.not-allowed {
    cursor: not-allowed !important;
  }
}

.arrow-gray {
  color: #dcdcdc !important;
  padding: 0 5px;
}
.AdminOrderDetail .el-card__header {
  background: $background-gray-deep;
  padding: 10px 20px !important;
}
.AdminOrderDetail .cardBody {
  display: block;
  height: 200px;
  overflow: scroll;
}
.AdminOrderDetail .el-card {
  margin-top: 1rem;
  margin-left: 5%;
  border: 1px solid $background-gray-deep; // #d6d5d5;
}
.AdminOrderDetailHeader {
  width: 100%;
  margin: 5px auto 0 auto;
}
.AdminOrderDetailHeader button {
  margin: 0.5rem;
}
.AdminOrderDetailHeaderTopRight {
  width: 100%;
  font-weight: bold;
  margin-top: 0.5rem;
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.AdminOrderDetailHeaderTopRight .el-select {
  width: 220px;
  min-width: 220px;
}
.AdminOrderDetailHeaderTopLeft {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
}
.AdminOrderDetailHeaderTopCenter {
  margin-top: 0.8rem;
  text-align: center;
}
.AdminOrderDetailHeaderTopLeft button {
  margin-right: 2.5rem;
  margin-top: 2rem !important;
}
.AdminOrderDetail .adminOrderDetailTable ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.AdminOrderDetail .adminOrderDetailTable ::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: $background-gray-deep-blue;
}
.AdminOrderDetail-Toolbar {
  display: flex;
  align-items: center;
  padding: 10px;
}
.AdminOrderDetail .adminOrderDetailTable {
  width: 100%;
  border: 1px solid $--border-color-lighter;
  border-collapse: collapse;
}
.AdminOrderDetail .adminOrderDetailTable-th,
.AdminOrderDetail .adminOrderDetailTable-td {
  text-align: left;
  padding: 10px 5px;
}
.AdminOrderDetail .adminOrderDetailTable-td {
  width: 50%;
  padding-left: 1rem !important;
  font-size: 12px !important;
  border: 1px solid $--border-color-lighter;
  border-collapse: collapse;
}
.AdminOrderDetail .adminOrderDetailTable-th {
  background: $background-gray-deep;
  font-size: 12px !important;
}
.AdminOrderDetail .basic-info {
  margin: 1.3rem 2rem;
}
.AdminOrderDetail .basic-info .header-left {
  text-align: left;
  padding-left: 0.3rem;
  background: $background-gray-deep !important;
}
.Product-Table {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.Product-Table .Product-Table-HeaderCell,
.Product-Table .Product-Table-Cell {
  text-align: right;
}
.Product-Table th {
  color: $text-base !important;
  background: $background-gray-deep !important;
}
.Product-Table .el-table__row {
  cursor: default !important;
}
.AdminOrderDetail-Toolbar-tr {
  padding-left: 1.5rem;
}
.no-hover:hover > td {
  background-color: initial !important;
}
.SelectTabletType-CaretRightIcon {
  font-size: 30px;
}
.adminOrderDetailTable-th .customer-edit-btn {
  float: right;
}
.AdminOrderDetailHeaderTopLeft .el-input__suffix {
  display: none;
}
.AdminOrderDetailHeaderTopLeft .el-select .el-input__inner {
  color: white;
  background-color: $red-base;
  border-color: $red-base;
}
.AdminOrderDetailHeaderTopLeft .el-select {
  width: 150px !important;
  text-align: right !important;
}
.AdminOrderDetailHeaderTopLeft .el-input--suffix .el-input__inner {
  padding-left: 40px !important;
}
.FormGroup {
  margin-top: 0.5rem;
}
#AdminOrderDetailHeaderOptions .el-input__inner {
  text-align: center !important;
}
.AdminOrderDetailHeaderTopRight #assignUserSelectBox::placeholder {
  color: black !important;
}
#btnText {
  padding-top: 2rem;
  width: 50%;
  color: $text-lighter;
}
.AdminOrderDetailDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.AdminOrderDetailDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 5rem;
  padding-top: 4.5rem;
  margin-top: 1rem;
  height: 60%;
}
.AdminOrderDetailDialog .assignerDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 2rem;
  padding-top: 3rem;
  margin-top: 1rem;
  height: 60%;
}
.AdminOrderDetailDialog .assignerDialog .dialog-text {
  font-size: 19.5px;
  font-weight: bold;
}
.AdminOrderDetailDialog .el-button {
  border: none;
}
.AdminOrderDetailDialog .el-dialog__close {
  display: none;
}
.AdminOrderDetailDialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.AdminOrderDetailDialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 4rem;
  padding-top: 4.5rem;
  margin-top: 1rem;
  height: 15%;
}
.AdminOrderDetailDialog .el-button {
  border: none;
}
.AdminOrderDetailDialog .el-dialog__close {
  display: none;
}
.AdminOrderDetailDialog .blue-text-btn {
  color: $blue-extra-deep;
}
.AdminOrderDetailDialog .dateInputDialog .date-input {
  width: 280px !important;
  margin: 0.5rem auto 0;
}
.AdminOrderDetailDialog .dateInputDialog .el-dialog__footer {
  margin-top: -1.5rem !important;
  margin-right: 0.3rem !important;
}
.AdminOrderDetailDialog .dialog-footer {
  margin-top: 1rem;
}
.AdminOrderDetailDialog .el-dialog__footer {
  padding: 10px 20px 20px;
  width: 100%;
  margin-top: 2rem;
}
.AdminOrderDetailDialog .el-dialog el-dialog--center {
  height: 60%;
}
@media (max-width: 1024px) {
  .AdminOrderDetailDialog .el-dialog {
    height: 40% !important;
  }
  .AdminOrderDetailDialog .el-dialog__footer {
    margin-top: 1rem !important;
  }
  .container {
    width: 520pt;
    text-align: left;
  }
  .table {
    width: 520pt;
    align-self: center;
    vertical-align: top;
    margin: 0.3rem auto auto auto;
  }
  .table .row {
    display: table;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
  }
  .table .row .col.empty {
    display: table-cell;
    padding: 0.3rem;
    border: none;
    border-bottom: none;
    text-align: center;
  }
  .table .row .col.th {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    border-bottom: none;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    border-bottom: none;
    width: auto;
  }
  .table .row .col.th.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: auto;
  }
}
@media (max-width: 768px) {
  .AdminOrderDetailDialog .el-dialog {
    height: 30% !important;
    width: 45% !important;
  }
  .AdminOrderDetailDialog .el-dialog__footer {
    margin-top: 1rem !important;
  }
  .AdminOrderDetailHeaderTopRight {
    width: 394px;
  }
  .Product-Table .el-table__header {
    width: auto !important;
  }
  .Product-Table .el-table__body {
    width: 108% !important;
  }
  .Product-Table .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto !important;
  }
  .Product-Table .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid $--border-color-lighter !important;
  }
  .AdminOrderDetailHeaderTopLeft button {
    margin-right: 8.5rem;
  }
  .container {
    width: 520pt;
    text-align: left;
  }
  .table {
    width: 520pt;
    align-self: center;
    margin: 0.3rem 0 !important;
  }
  .table .row {
    display: table;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
  }
  .table .row .col.empty {
    display: table-cell;
    padding: 0.3rem;
    border: none;
    border-bottom: none;
    text-align: center;
  }
  .table .row .col.th {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    border-bottom: none;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    border-bottom: none;
    width: auto;
  }
  .table .row .col.th.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: auto;
  }
}
.AdminOrderDetail .el-form-item {
  margin-bottom: 0px !important;
}
#editBtn .el-button {
  padding: 9px 14px !important;
}
.order-status {
  text-align: center;
  height: 40px;
  margin-top: 1rem;
  margin-bottom: -0.5rem;
}
.statusBold {
  font-weight: 600;
}
.order-management-dialog-body {
  min-height: 160px;
}
.order-management-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
.order-management-item {
  width: 360px;
  max-width: 100%;
  text-align: center;
}
.order-management-preview-frame {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 10px;
  background: #fff;
}
/* OrderFormStep3 .isActiveProduct / 注文作成の編集中プレビューと同じ */
.order-management-preview-frame.order-management-preview-frame--current {
  border: 3px solid $blue-deep;
}
/* Layout Images Admin Section */
.layout-images-admin-section {
  margin: 20px 0;
  border: 1px solid #C5C5C5;
}
.layout-images-admin-table {
  width: 100%;
  margin-bottom: 0;
}
.layout-images-admin-subheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}
.layout-images-admin-count {
  font-size: 14px;
  color: #333;
}
.layout-images-admin-actions {
  display: flex;
  gap: 8px;
}
.layout-images-admin-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
  padding: 0 16px 16px;
}
/* カードの幅・高さは全て統一 */
.layout-image-admin-card {
  width: 180px;
  text-align: center;
}
.layout-image-admin-card-inner {
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #fff;
}
.layout-image-admin-card-inner:hover {
  border-color: #409eff;
}
.layout-image-admin-approved .layout-image-admin-card-inner {
  border-color: #67c23a;
  border-width: 2px;
}
.layout-image-admin-thumb-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.layout-image-admin-thumb {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.layout-image-admin-approved-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #67c23a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
}
.layout-image-admin-approved-badge i {
  font-weight: bold;
}
.layout-image-admin-delete {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  color: #909399;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
  padding: 0;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  z-index: 2;
}
.layout-image-admin-delete:hover {
  color: #fff;
  background: #f56c6c;
  border-color: #f56c6c;
}
.layout-image-admin-delete:active {
  transform: scale(0.95);
}
.layout-image-admin-filename {
  font-size: 12px;
  color: #333;
  margin-top: 6px;
  word-break: break-all;
}
.layout-image-admin-add-card {
  width: 180px;
  text-align: center;
}
.layout-image-admin-add-inner {
  width: 100%;
  height: 220px;
  border: 1px dashed #c0c4cc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 32px;
  color: #999;
  transition: border-color 0.2s;
  box-sizing: border-box;
  background: #fafafa;
}
.layout-image-admin-add-inner:hover {
  border-color: #409eff;
  color: #409eff;
}
.layout-image-admin-add-card .el-upload {
  display: block;
}
/* Confirmed: approved layout above お客様情報 */
.approved-layout-above-info {
  text-align: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.approved-layout-above-info-title {
  font-size: 18px;
  color: $--color-primary;
  margin-bottom: 5px;
  margin-left: 16px;
  text-align: left;
}
.approved-layout-above-info-img {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}
.approved-layout-above-info-img:hover {
  opacity: 0.85;
}

.layout-image-dialog-content {
  padding: 0 16px;
}
.layout-image-dialog-filename {
  font-size: 16px;
  margin-bottom: 12px;
}
.layout-image-dialog-preview {
  text-align: center;
  margin-top: 16px;
}
.layout-image-full {
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
}
</style>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.statusButton {
  width: 220px;
}

.AdminOrderDetail {
  width: 98%;
  margin-left: 1rem;
}
.black-text {
  color: $text-base;
}
.AdminOrderDetail {
  width: 98%;
  margin-left: 1rem;
}
.RodanSettingData {
  width: 98%;
  margin-left: 1rem;
}
.black-text {
  color: $text-base;
}

#productTable >>> .cell {
  white-space: nowrap !important;
}
#productTable >>> .TextLeft {
  text-align: left !important;
}
#productTable >>> .TextCenter {
  text-align: center !important;
}
#productTable >>> .Product-Table-HeaderCell:not(.TextLeft) {
  text-align: center !important;
}
.container {
  width: 520pt;
  text-align: left;
}
.table {
  width: 520pt;
  align-self: center;
  margin: 0.3rem 0 !important;
}
.table .row {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}
.table .row .col.empty {
  display: table-cell;
  padding: 0.3rem;
  border: none;
  border-bottom: none;
  text-align: center;
}
.table .row .col.th {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: auto;
}
.table .row .col.th.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: auto;
}
.Note {
  white-space: pre-wrap;
}
.UserUploadImgTitleConfirm {
  font-size: 12px;
  font-weight: bold;
  margin-left: 20px;
}
.UserUploadImgConfirm {
  width: 50%;
  margin-left: 100px;
}
</style>
